/** Hardcoded: master presentation is only for this client */
export const EWAY_ENERGY_CLIENT_NAME = 'E-way Energy GmbH';

/**
 * Masterpräsentation is shown only to users of the organization "E-way Energy GmbH", checked by
 * name (legacy `client` or one of `clients`). Not checked by the backend.
 * @param {Object|null} user current user
 * @returns {boolean}
 */
export const isMasterPresentationVisible = (user) => {
  if (!user) {
    return false;
  }
  if (user.client && user.client.name === EWAY_ENERGY_CLIENT_NAME) {
    return true;
  }
  if (!user.clients) {
    return false;
  }
  return user.clients.some((client) => client.name === EWAY_ENERGY_CLIENT_NAME);
};
